<div style="display: flex; justify-content: center; align-items: center;">
    <!-- svelte-ignore a11y-missing-attribute -->
    <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FNew_York&bgcolor=%23ff6969&showPrint=0&showTabs=0&showTz=0&showCalendars=0&title=ACM%20Events&src=ODEwYjEyOWM1NzQwOTY3MmE5ZmIwODRhMzU3NWQ2M2VkOGU2YWJmOGNhOTgwMmQ3N2JiNDQ1Y2U0Y2I5NzkyY0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23F09300" 
            style="border:solid 1px #777" width="800" height="600" frameborder="0" scrolling="no">
    </iframe>
</div>
